import React, { useMemo } from 'react';
import MainReservationBtn from 'pages/Product/MainReservationBtn';

import CostSummaryPanel from '../MainBlock/CostSummaryPanel';

import style from './fixedReservationBar.module.scss';

const FixedReservationBar = ({
  handleAddProduct,
  product,
  isBookNowDisabled,
  postcodeError,
  calculatedPrice,
}) => {
  const currBtn = useMemo(() => {
    return (
      <MainReservationBtn
        handleAddProduct={handleAddProduct}
        product={product}
        isBookNowDisabled={isBookNowDisabled}
        postcodeError={postcodeError}
      />
    );
  }, [handleAddProduct, product, isBookNowDisabled, postcodeError]);

  return (
    <div className={style.fixedBarWrapper}>
      <CostSummaryPanel calculatedPrice={calculatedPrice} isBottomPanel />
      {currBtn}
    </div>
  );
};

export default FixedReservationBar;
